import ARIAText from "../ARIAText";
import Button from "../Button";
import LottieAnimation from "../LottieAnimation";
import LottieSprite from "../LottieSprite";
import NineSlicedSprite from "../NineSlicedSprite";
import ScrollingImage from "../ScrollingImage";
import SoundButton from "../SoundButton";

export class GameObjectFactoryPlugin extends Phaser.Plugins.BasePlugin {
	//both are injected
	scene: Phaser.Scene;
	displayList: Phaser.GameObjects.DisplayList;

	constructor(pluginManager: Phaser.Plugins.PluginManager) {
		super(pluginManager);

		// Override Text Creation so that we create Text with ARIA support built in
		pluginManager.removeGameObject("text");
		pluginManager.registerGameObject("text", this.createText);
		pluginManager.registerGameObject("button", this.createButton);
		pluginManager.registerGameObject("soundButton", this.createSoundButton);
		pluginManager.registerGameObject("scrollingImage", this.createScrollingImage);
		pluginManager.registerGameObject("lottie", this.createLottie);
		pluginManager.registerGameObject("lottieAnimation", this.createLottieAnimation);
		pluginManager.registerGameObject("nineSlicedSprite", this.createNineSlicedSprite);
	}

	createButton(
		x: number,
		y: number,
		texture: string,
		frame?: string | number,
		callback?: () => any,
		callbackContext?: CallbackContext,
		bounce?: boolean
	): Button {
		return this.scene.add.existing(new Button(this.scene, x, y, texture, frame, callback, callbackContext, bounce)) as Button;
	}

	createText(x: number, y: number, text: string | string[], style: Phaser.Types.GameObjects.Text.TextStyle): ARIAText {
		return this.scene.add.existing(new ARIAText(this.scene, x, y, text, style));
	}

	createSoundButton(x: number, y: number, texture: string, muteCallback?: () => any, muteCallbackContext?: CallbackContext): SoundButton {
		return this.scene.add.existing(new SoundButton(this.scene, x, y, texture, muteCallback, muteCallbackContext)) as SoundButton;
	}

	createScrollingImage(x: number, y: number, texture: string, scrollSpeedX: number, scrollSpeedY: number): ScrollingImage {
		return this.scene.add.existing(new ScrollingImage(this.scene, x, y, texture, null, scrollSpeedX, scrollSpeedY)) as ScrollingImage;
	}

	createLottie(x: number, y: number, texture: string, autoplay?: boolean, loop?: boolean): LottieSprite {
		return this.scene.add.existing(new LottieSprite(this.scene, x, y, texture, autoplay, loop)) as LottieSprite;
	}

	createLottieAnimation(x: number, y: number, texture: string, autoplay?: boolean, loop?: boolean): LottieAnimation {
		return this.scene.add.existing(new LottieAnimation(this.scene, x, y, texture, autoplay, loop)) as LottieAnimation;
	}

	createNineSlicedSprite(
		x: number,
		y: number,
		texture: string,
		width: number,
		height: number,
		top: number,
		right: number,
		bottom: number,
		left: number,
		onRender?: () => any,
		useRenderHack?: boolean
	): NineSlicedSprite {
		return this.scene.add.existing(
			new NineSlicedSprite(this.scene, x, y, texture, width, height, top, right, bottom, left, onRender, useRenderHack)
		) as NineSlicedSprite;
	}
}

//typings only
export interface GameObjectFactory extends Phaser.GameObjects.GameObjectFactory {
	button(
		x: number,
		y: number,
		texture: string,
		frame?: string | number,
		callback?: () => any,
		callbackContext?: CallbackContext,
		bounce?: boolean
	): Button;
	text(x: number, y: number, text: string, style?: Phaser.Types.GameObjects.Text.TextStyle): ARIAText;
	soundButton(x: number, y: number, texture: string, muteCallback?: () => any, muteCallbackContext?: CallbackContext): SoundButton;
	scrollingImage(x: number, y: number, texture: string, scrollSpeedX: number, scrollSpeedY: number): ScrollingImage;
	lottie(x: number, y: number, texture: string, autoplay?: boolean, loop?: boolean): LottieSprite;
	lottieAnimation(x: number, y: number, texture: string, autoplay?: boolean, loop?: boolean): LottieAnimation;
	nineSlicedSprite(
		x: number,
		y: number,
		texture: string,
		width: number,
		height: number,
		top: number,
		right: number,
		bottom: number,
		left: number,
		onRender?: () => any,
		useRenderHack?: boolean
	): NineSlicedSprite;
}
